import React from 'react';
import { translate } from '../../Services/translation';

export const PLACEMENTS = ['A', 'B', 'C'];

const AccessoryPlacement = ({ selectedAccessory, selectedPlacement, setSelectedPlacement }) => {
    const placementDefaultClasses = 'product-detail__placement-box';
    const SELECTED_FILTER = 'product-detail__placement-box--selected';
    
    return (
        <>
            <h5 className="product-detail__placement-title">
                {translate('product.placement')}
            </h5>
            <ul className="product-detail__placement-list">
                {PLACEMENTS.map((value, i) => (
                    <li key={i}
                        data-item-id={selectedAccessory}
                        data-placement={value}
                        onClick={() => setSelectedPlacement(value)}
                        className={`${placementDefaultClasses} ${selectedPlacement === value ? SELECTED_FILTER : ''}`}>
                        {value}
                    </li>
                ))}
            </ul>
        </>
    )
};

export default AccessoryPlacement;
